// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"537":"c94abda6","714":"aa2fd52a","821":"0e85747e","935":"796e1297","954":"8526874e"}[chunkId] + ".chunk.js";
};